import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=1e9b9742&"
import script from "./Remark.vue?vue&type=script&lang=js&"
export * from "./Remark.vue?vue&type=script&lang=js&"
import style0 from "./Remark.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports